import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { Feed, Icon, Table} from 'semantic-ui-react'
import { GetTaxExcemptionEligibilityHistory } from '../../api/services/shared';
import { dateFormat, dateTimeFormat, TaxAuthorityResultCodeTitles } from '../shared/constants'
import { useTextResources } from '../../language';
import moment from 'moment';
import './style.css'


const TaxExemptHistory = ({ reservationId }) => {
    const [historyLines, setHistoryLines] = useState([]);

    const text = useTextResources()

    useEffect(() => {    
        if(reservationId){  
            (async () => {
                const historyLines = await GetTaxExcemptionEligibilityHistory({ ReservationId: reservationId});
                historyLines.map((line)=> {
                  line.Response = JSON.parse(line.Response);
                  line.showDetails = false;
                }) 
                setHistoryLines(historyLines)
            })()
        }
    }, [reservationId])

    const showHistoryLineDetails = (id) => {
      setHistoryLines(historyLines.map(line => { 
        if(line.Id === id) {
          line.showDetails = !line.showDetails;
        }
        return line;
      }))
    }

	return (
          <Feed style={{overflowY:"scroll", maxHeight:"350px"}}>
              {historyLines.map(hline => (  
                  <Feed.Event key={hline.Id}>
                  <Feed.Label>
                    <Icon name='globe' />
                  </Feed.Label>
                  <Feed.Content>
                    <Feed.Date>{moment(hline.DateTime).format(dateTimeFormat)}</Feed.Date>
                    <Feed.Summary>
                      <p><b color={hline.IsTaxExemptEligible ? 'green' : 'red'}>{text(TaxAuthorityResultCodeTitles[hline.TaxAuthorityCode])}</b>&nbsp;&nbsp;
                        <Icon name={hline.showDetails ? 'angle up': 'angle down'} onClick={() =>showHistoryLineDetails(hline.Id)}/>
                        <br/>
                        <span>{hline.TaxAuthorityMessage}</span> 
                      </p>
                    </Feed.Summary>
                    {hline.showDetails &&
                    <Feed.Extra>
                      <Table basic='very' className="history-details">
                        <Table.Body>
                            <Table.Row>
                              <Table.Cell>{text("Country")}</Table.Cell>
                              <Table.Cell>{hline.Response?.Request?.CountryCode}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                              <Table.Cell>{text("Passport")}</Table.Cell>
                              <Table.Cell>{hline.Response?.Request?.PassportNumber}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                              <Table.Cell>{text("CheckInDate")}</Table.Cell>
                              <Table.Cell>{moment(hline.Response?.Request?.CheckinDate).format(dateFormat)}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                              <Table.Cell>{text("CheckOutDate")}</Table.Cell>
                              <Table.Cell>{moment(hline.Response?.Request?.CheckoutDate).format(dateFormat)}</Table.Cell>
                            </Table.Row>
                        </Table.Body>
                      </Table>
                    </Feed.Extra>
                    }
                    </Feed.Content>
                </Feed.Event>
              ))}  
          </Feed>
    )
}
 
TaxExemptHistory.propTypes = {
	reservationId: PropTypes.number,
};

export default TaxExemptHistory
